import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5875 6.10207C10.8935 6.10207 10.2307 6.22095 9.61619 6.43815L8.56519 3.46459C9.51256 3.12975 10.5305 2.94824 11.5875 2.94824C12.3678 2.94824 13.1273 3.04717 13.8531 3.23399C15.2597 3.59601 16.5324 4.28602 17.5855 5.21547L15.4985 7.58002C14.8096 6.97199 13.9801 6.5233 13.067 6.28828C12.5958 6.167 12.1004 6.10207 11.5875 6.10207ZM6.78164 8.56727C7.21526 7.96448 7.75956 7.44642 8.38417 7.04317L6.67356 4.39355C5.71708 5.01106 4.88481 5.80337 4.22144 6.72553L6.78164 8.56727ZM5.67214 12.0156C5.67214 11.1333 5.86431 10.3003 6.20758 9.55237L3.34123 8.23682C2.81237 9.3891 2.51831 10.6701 2.51831 12.0156C2.51831 16.51 5.78669 20.2379 10.0763 20.9575L10.5981 17.8472C7.80251 17.3782 5.67214 14.9441 5.67214 12.0156ZM16.3927 8.56684C17.0908 9.53731 17.5016 10.726 17.5016 12.0153C17.5016 15.1145 15.1165 17.6582 12.0828 17.9085L12.3421 21.0516C16.9979 20.6675 20.6555 16.7694 20.6555 12.0153C20.6555 10.0434 20.0242 8.21425 18.9529 6.7251L16.3927 8.56684Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgDonut = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgDonut;
